export const GIGSKY_LINK = 'https://gigsky.pxf.io/6ygQnN';
